import { Injectable, Inject, PLATFORM_ID, NgZone } from "@angular/core";
import { formatDate, isPlatformBrowser } from "@angular/common";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { environment } from "../../../../environments/environment";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ThankuResponse } from "../../payload-Model/billingFormModel";
import { secureStorage } from "../encryption/secureservice";
import { ApiService } from "../apiService.service";
import { ClevertapService } from "../clevertap/clevertap.service";
import { RegexService } from "../../form-validation/regex.service";
import { BehaviourSubjectService } from "../behaviour-subject.service";
import { Router } from "@angular/router";
declare const gtag: Function;

function _window(): any {
    // return the global native browser window object
    return window;
}

@Injectable({
  providedIn: "root",
})
export class PaymentService {

  environment1 = environment.s3bucket.url;
  imageUrl: any;
  baseUrl: any;
  payMessage: any;

  sub: Subscription = new Subscription();
  leadInfo: any;
  loadAPI: Promise<any>;

  ccavenue: any;
  constructor(
    private localStorage: secureStorage,
    private ngZone: NgZone,
    private apiService: ApiService,
    private behaviorService : BehaviourSubjectService,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private router: Router,
    private spinnerService: NgxSpinnerService,private regexService: RegexService,
    @Inject(PLATFORM_ID) private platformId: Object, private cleverService: ClevertapService,

  ) {
    this.loadAPI = new Promise((resolve) => {
      this.regexService.loadScript();
      resolve(true);
    });

  }
  get nativeWindow(): any {
    if (isPlatformBrowser(this.platformId)) {
      return _window();
    }
  }

  async makePayment(orderLeadData: any, orderDetails: any, isBookingPageData: any, isfniPayment: any, optyData: any, paymentType: any,
    totalPayableAmount?: any, aadharno?:any) {
    await this.getEncryptionccavenue();
    let totalPayableAmount1 = totalPayableAmount == '' ? 0 : totalPayableAmount;
      this.baseUrl = window.location.href;
    let dealerData = orderLeadData.dealer_info
    let razorpayData = orderLeadData.razor_pay_detail
    let vehicleData = orderLeadData.vehicle_info
    let userData = orderDetails.user
    let orderData = orderLeadData;
    let VasData = orderData.vas_data.length > 0 ? orderData.vas_data[0] : null;
    let isVasAvailable = orderData.vas_data.length > 0 ? true : false;
    let currentDateTime = formatDate(new Date(), "yyyy-MM-dd HH:mm:ss", "en-US");
    let isBookingPage = isBookingPageData;
    let image = vehicleData["images"] ? vehicleData["images"] : vehicleData["image"] ? vehicleData["image"] :vehicleData["images"]
    if (image ) {
      if (image?.image_url) {
        this.imageUrl = image.image_url;
      } else {
        image.filter((image1: any) => image1.is_cover === true)
          .map((img: any) => {
            this.imageUrl = img["image_url"];
          });
      }
    }
    let data: any = {
      aadhar_number:aadharno ? aadharno :'',
      lead_type: orderLeadData.lead_type == 'finance' || orderLeadData.lead_type == 'FINANCE' ? "FINANCE" : "BOOKING",
      // otp_number: this.otpInputValue,
      mm_geography: orderData?.mm_geography ? orderData?.mm_geography : "",
      division_id: dealerData?.division_id ? dealerData?.division_id : "",
      lob: vehicleData.lob ? vehicleData.lob : "",
      mobile_number: userData.mobile_number,
      email_id: userData.email_id,
      first_name: userData.first_name,
      last_name: userData.last_name ? userData.last_name : '.',
      address_one: !isBookingPage ? orderData.address_one : optyData ? orderData.address_two : userData.first_name + userData.state + userData.mobile_number + currentDateTime,
      address_two: orderData.address_two,
      state: orderData?.state,
      state_code: orderData?.state_code,
      district: orderData.district,
      organization_name:
        // vehicleData.lob == "HCV Cargo" || vehicleData.lob == "MCV Trucks" || vehicleData.lob == "HCV Const" || vehicleData.lob == "ICV Trucks" ?
        userData?.first_name.trim() + userData?.last_name.trim() + userData?.mobile_number.trim()
      // : ""
      ,
      vehicle_application: "NA",
      body_type: "NA",
      usage_category: "",
      vc_description: vehicleData["product_description"] ? vehicleData["product_description"] : "",
      vc_number: vehicleData["vehicle_number"] ? vehicleData["vehicle_number"] : "",
      ppl: vehicleData["ppl"] ? vehicleData["ppl"] : "",
      vc_id: vehicleData["vehicle_id"] ? vehicleData["vehicle_id"] : "",
      pl: vehicleData["pl"] ? vehicleData["pl"] : "",
      quantity: "" + orderData.quantity,
      amc: orderData.amc,
      lease_interest: orderData.lease_interest,
      finance_account_id: orderData.finance_account_id,
      finance: orderData.finance ? orderData.finance : "SELF",
      model: vehicleData["model"] ? vehicleData["model"] : "",
      is_tml: 'True',
      interested_in_exchange: orderData.interested_in_exchange,
      brand: '',
      registration_number: '',
      pi_for_exchange: '',
      chassis_number: '',
      manufacture_year: '',
      mileage: '',
      action_type: razorpayData.length == 0 ? 'Unbilled' : 'Billed',
      channel: orderData.lead_channel,
      source:orderLeadData?.source ?  orderLeadData.source : '',
      medium:orderLeadData?.medium ? orderLeadData.medium : '',
      campaign:orderLeadData?.campaign ? orderLeadData.campaign : '',
      campaign_id:orderLeadData?.campaign_id ? orderLeadData.campaign_id : '',
      lead_origin:orderLeadData?.lead_origin,
      ex_showroom_price:orderLeadData?.ex_showroom_price

    };



    if((data.address_one).length >( isBookingPage ?  60 : 50)){
      data["address_one"] = data.address_one.trim()
      ? (data.address_one.trim()).substring(0,(isBookingPage ?  59 : 49))
        : (userData.first_name.trim() +
          userData.state +
          userData.mobile_number +
      currentDateTime).substring(0,(isBookingPage ?  59 : 49))
    }


    if ((data.organization_name).length > 50) {
      data['organization_name'] = userData?.first_name.trim() +
        userData?.mobile_number;
    }
      if(data.organization_name.length > 50){
          data['organization_name'] = (userData?.first_name.trim()).substring(0,39) +
          userData?.mobile_number; }
    data["payment_gateway_type"] = paymentType == "ccavenue"
      ? "CCAVENUE" : paymentType == "razorpay"
        ? "RAZORPAY"
        : "";
    data["down_payment"] = razorpayData.length == 0 ? orderData?.product?.down_payment
      : totalPayableAmount1 > 0 ? Number(totalPayableAmount) :
        orderData?.payment_info.length > 0 ? orderData?.payment_info?.amount / orderData?.quantity
          : orderData?.product?.down_payment


    data['dse_first_name'] = orderData?.first_name
    data['dse_last_name'] = orderData?.last_name
    data['dse_username'] = orderData?.username
    data['retry_payment'] = 'True';
    // && data["payment_gateway_type"] == 'CCAVENUE'
    if (orderData.vas_data.length > 0 ) {

      let vas_data = {
        "payment_gateway_type": paymentType == "ccavenue" ? "CCAVENUE" : "RAZORPAY",
        "vas_category": VasData.vas_category,
        "vas_payble_amount": VasData.vas_payble_amount ? Number(VasData.vas_payble_amount) : 0,
        "chassis_number": "",
        "vc_number": VasData.vehicle_number,
        "application": VasData.application,
        "terrian": VasData.terrian,
        "avg_monthly_km": VasData.avg_monthly_km,
        "no_of_years": (VasData.no_of_years).toString(),
        "quantity": VasData.quantity,
        "channel": VasData.channel,
        "fuel_type": VasData.fuel_type,
        "retry_payment": 'True',
        'recommended_quantity': VasData.recommended_quantity,
        "vas_id": VasData.id
      }
      data['vas_data'] = [vas_data];
    }

    data["stock"] = orderData.stock;

    //for FNI
    if (data['lead_type'] == 'FINANCE') {
      data["pan_no"] = userData.pan_no;
      data["taluka"] = orderData.taluka;
      data["city"] = orderData.city;
      data["pincode"] = orderData.pincode;
    }
    //IF BOOKING VEHICLE VIA FNI
    if (data['lead_type'] == 'FINANCE') {
      data["opty_id"] = orderData.opty_id;
      data["pan_no"] = userData.pan_no;
    }
    // FOR RETRY PAYMENT FUNCTIONALITY
    if (orderData.row_id && isBookingPage) {
      data["row_id"] = orderData.row_id;
    }
    if (orderData.opty_id && isBookingPage
    ) {
      data["opty_id"] = orderData?.opty_id;
    }
    //IF fni OPTY IS AVAILABLE
    if (optyData &&
      isBookingPage &&
      optyData?.opty?.division_id == data?.division_id &&
      optyData?.opty?.ppl_name == data?.ppl
    ) {
      data["opty_id"] = optyData?.opty?.opty_id;
    }

    if (isPlatformBrowser(this.platformId)) {
      //UTM PARAMS
      if (JSON.parse(this.localStorage.getItem("participant")) != null) {

        let participantSourceData = JSON.parse(this.localStorage.getItem("participant"));
        data["source"] = participantSourceData.source;
        data["medium"] = participantSourceData.medium;
        data["campaign"] = participantSourceData.campaign;
        data["term"] = participantSourceData.utm_term;
        data["content"] = participantSourceData.utm_content;
        data["campaign_id"] = participantSourceData.utm_campaign_id;
        data["keyword"] = participantSourceData.utm_keyword;
      }
    }
    this.spinnerService.show();

    this.clevertapPayment(vehicleData)
    this.sub.add(this.apiService.generateLead(data).subscribe({
      next: (response: any) => {
        if (isBookingPage) {
          if (response.success) {
            this.leadInfo = response.data;
            this.clevertap();

            this.spinnerService.hide();
            if (razorpayData.length == 0) {
              this.toastrService.success(response.data.msg);
              this.router.navigate(["account"], {
                queryParams: { page_name: "my-request" },
              });
            } else {
              if (paymentType == 'ccavenue') {
                this.getCcAvenueEncryptionKey(response, razorpayData, userData, vehicleData, response.data, isVasAvailable, data['vas_data']);

              } else {
                // this.GoogleProcessPayment("click_billingdetails_proceedtopay_success");
                let razororderDetails = {
                  razorpay_account_id: response["data"].razorpay_account_id,
                  razorpay_access_key: response["data"].razorpay_access_key,
                  order_id: response["data"].payment_order_id,
                  pay_amount: response["data"].payment_amount,
                  product_name: response["data"]?.lead_info.pl,
                  product_description: response["data"]?.lead_info.vehicle_number,
                  shopping_order_id: response["data"].lead_row_id,
                  email: response["data"].email_id,
                  contact: response["data"].mobile_number,

                };
                this.payMessage = "Request In Process";
                this.payWithRazor(razororderDetails, vehicleData, response.data);
                this.toastrService.success(response.data.msg);
              }
              if (isPlatformBrowser(this.platformId)) {
                try {
                  // this.cleverService.onPaymentOptionSelected(
                  //   "Online Transfer",
                  //   vehicleData["id"],
                  //   vehicleData["model"],
                  //   this.imageUrl,
                  //   "Top Navigation",
                  //   this.baseUrl
                  // );
                } catch (error) { }
              }
              if (isPlatformBrowser(this.platformId)) {
                localStorage.removeItem("participant");
              }
            }
          } else {
            if (razorpayData.length == 0) {
              this.spinnerService.hide();
              this.toastrService.warning(response.data.msg);
            } else {
              this.spinnerService.hide();
              this.toastrService.warning(response.data.msg);
            }
          }
        } else {
          if (response.success) {
            this.toastrService.success(response.data.msg);
            if (isPlatformBrowser(this.platformId)) {
              localStorage.removeItem("participant");
            }
          } else {
            this.spinnerService.hide();
            this.toastrService.warning(response.data.msg);
          }
        }
      },

      error: (error: any) => {
        if (isPlatformBrowser(this.platformId)) {
          // this.startTimer(0);
          this.spinnerService.hide();
          this.toastrService.warning(error.data ? error.data.msg : 'Something went wrong, Please try again !');
          window.location.reload();
        }
      },
      complete: () => {
      }
    }));
  }

  clevertapPayment(vehicleData) {
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onPaymentOptionSelected(
          "Online Transfer",
          vehicleData["product_id"],
          vehicleData["model"],
          this.imageUrl,
          "Top Navigation"
        );
      } catch (error) { }
    }
  }

  // clevertapPayementcompFailed(data:any) {
  //   let baseUrl = window.location.href;
  //   if (isPlatformBrowser(this.platformId)) {
  //     try {
  //       this.cleverService.onPaymentCompleted(
  //         "Failure",
  //         "Online Transfer",
  //         data["id"],
  //         data["model"],
  //         this.imageUrl,
  //         "Top Navigation",
  //         baseUrl,
  //         data['sub_lob'],
  //         data['lob'],
  //         data['ppl'],
  //         data['price_range'] ? data['price_range'] : "",
  //         data['down_payment'],
  //         data["amount"] * data["quantity"],
  //       );
  //     } catch { }
  //   }
  // }

  payWithRazor(orderDetails: any, vehicleData: any, leadInfo: any) {

    const ResponseData: PaymentResponse = {} as PaymentResponse;
    const options: any = {
      key: orderDetails.razorpay_access_key,
      amount: orderDetails.pay_amount,
      currency: "INR",
      name: orderDetails.product_name, //'VSS', // company name or product name
      description: orderDetails.product_description, //'Star City Bus',  // product description
      image: `${this.environment1}assets/images/tataMLogo.webp`, // company logo or product image
      order_id: orderDetails.order_id, // order_id created by you in backend
      account_id: orderDetails.razorpay_account_id,
      prefill: {
        email: orderDetails.email,
        contact: orderDetails.contact,
      },
      modal: {
        escape: false,
      },
      notes: {
        shopping_order_id: orderDetails.shopping_order_id,
      },
      theme: {
        color: "#0c238a",
      },
    };
    options.handler = (response: any) => {
      this.payMessage =
        "Your payment of ₹" +
        ((orderDetails.pay_amount / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) +
        "/- received against Request ID " +
        orderDetails.shopping_order_id +
        ".";
      // this.isVerifyOtp = true;
      // this.isconfirm = true;
      // this.isProcess = false;
      options.response = response;
      ResponseData.razorpay_payment_id = response.razorpay_payment_id;
      ResponseData.razorpay_order_id = response.razorpay_order_id;
      ResponseData.razorpay_signature = response.razorpay_signature;
      this.sub.add(this.apiService.getPaymentDetail(ResponseData).subscribe({
        next: (response: any) => {
          if (response.success) {

            // this.isProcess = false;
            // this.isconfirm = true;
            // this.googleAnlyaticspayment(
            //   "click_payment_success",
            //   orderDetails.shopping_order_id,
            //   this.payMessage,
            //   orderDetails.pay_amount
            // );
            // this.clevertapPayementFailed();
              const objthank: ThankuResponse = {} as ThankuResponse;
              objthank.headMessage = "Thank You !";
              objthank.payMessage = this.payMessage;
              objthank.Image = this.imageUrl;
              objthank.vehicleID = vehicleData["id"] ? vehicleData["id"] : vehicleData["product_id"] ? vehicleData["product_id"] : vehicleData["id"]
              objthank.vehicleModel = vehicleData["model"];
              objthank.orderAmount = response["data"].payment_amount / 100
              objthank.leadInfo = leadInfo;


            objthank.orderId = leadInfo.order_id ? leadInfo.order_id : leadInfo.payment_order_id ? leadInfo.payment_order_id :  leadInfo.payment_order_id;
              objthank.reqId = leadInfo.lead_row_id;
              objthank.transactionStatus = 'success';
              objthank.productUrl = window.location.href;
              objthank.payment_gateway = "RAZORPAY";

              localStorage.removeItem('Payresponse');
              this.localStorage.setItem("Payresponse", JSON.stringify(objthank));
            this.behaviorService.splitVasPay.next(true);

            if (isPlatformBrowser(this.platformId)) {
              try {
                // this.cleverService.onPaymentCompleted(
                //   "Success",
                //   "Online Transfer",
                //   vehicleData["id"],
                //   vehicleData["model"],
                //   this.imageUrl,
                //   "Top Navigation",
                //   this.baseUrl
                // );
              } catch { }
              // gtag("event", "conversion", {
              //   send_to: "AW-11093091987/qdJRCLHUzJcYEJPNzKkp",
              //   value: response["data"].payment_amount/100,
              //   currency: "INR",
              //   transaction_id: orderDetails.shopping_order_id,
              // });
            }
            // this.clevertapPayementcompFailed(leadInfo.booking_amount);

            this.ngZone.run(() => this.router.navigate(["/order-status"])).then();
          } else {
            // this.googleAnlyaticspayment(
            //   "click_payment_fail",
            //   orderDetails.shopping_order_id,
            //   this.payMessage,
            //   orderDetails.pay_amount
            // );

            // this.clevertapPayementcompFailed(vehicleData);
            this.clevertapPayementFailed();
            this.ngZone.run(() => this.router.navigate(["/order-status"])).then();
          }
        }
      }));
      // call your backend api to verify payment signature & capture transaction
    };
    options.modal.ondismiss = () => {
      this.payMessage =
        "Your payment against Request ID " +
        orderDetails.shopping_order_id +
        " of ₹" +

        ((orderDetails.pay_amount / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) +
        "/- is not received.";
      // this.isVerifyOtp = true;
      const objthank: ThankuResponse = {} as ThankuResponse;
      objthank.headMessage = "Sorry !";
      objthank.payMessage = this.payMessage;
      objthank.Image = this.imageUrl;
      objthank.vehicleID = vehicleData["id"];
      objthank.leadInfo = leadInfo;
      objthank.reqId = leadInfo.lead_row_id;
      objthank.vehicleModel = vehicleData["model"];
      objthank.orderAmount = orderDetails.payment_amount / 100;
      objthank.payment_gateway = "RAZORPAY";

        localStorage.removeItem('Payresponse');
        this.localStorage.setItem("Payresponse", JSON.stringify(objthank));
      this.behaviorService.splitVasPay.next(true);

      const ResponseDatas: PaymentResponse = {} as PaymentResponse;
      ResponseDatas.razorpay_order_id = orderDetails.order_id;
      this.sub.add(this.apiService.getPaymentCancelDetail(ResponseDatas).subscribe({
        next: (response: any) => {

          if (isPlatformBrowser(this.platformId)) {
            try {
              // this.cleverService.onPaymentCompleted(
              //   "Failure",
              //   "Online Transfer",
              //   vehicleData["id"],
              //   vehicleData["model"],
              //   this.imageUrl,
              //   "Top Navigation",
              //   this.baseUrl
              // );
            } catch { }
          }
          if (response.success) {


            // this.googleAnlyaticspayment(
            //   "click_payment_cancelled",
            //   orderDetails.shopping_order_id,
            //   this.payMessage,
            //   orderDetails.pay_amount
            // );
            this.ngZone.run(() => this.router.navigate(["/order-status"])).then();
          } else {

            // this.googleAnlyaticspayment(
            //   "click_payment_cancelled_fail",
            //   orderDetails.shopping_order_id,
            //   this.payMessage,
            //   orderDetails.pay_amount
            // );
            this.clevertapPayementFailed();

            this.ngZone.run(() => this.router.navigate(["/order-status"])).then();
          }
        }
      }));
    };
    const rzp = new this.nativeWindow.Razorpay(options);
    rzp.open();
    return ResponseData;
  }

  googleAnlyaticspayment() {
    try {
      // this.firebaseanalytics.Payment(eventname, RequestId, Message, amount, "BookNow");
    } catch (error) { }
  }

  getCcAvenueEncryptionKey(leadResponse: any, divData: any, userData: any, vehicleData: any, leadInfo: any, isVasAvailable, VasData) {

    let subAccId: string = "";
    divData.forEach((element: any) => {
      if (element.payment_gt_type == 'CCAVENUE') {
        subAccId = element.account_id;
      }
    });
    let finalAmount = leadResponse["data"]?.lead_info.final_amount / 100;
    if (isVasAvailable) {
      finalAmount = Number(finalAmount) + Number(VasData[0].vas_payble_amount)
    }

    let data = {
      "data": {
        "amount": Number(finalAmount),
        "billing_address": "",
        "billing_city": "",
        "billing_email": "",
        "billing_country": "India",
        "billing_name": userData?.first_name + " " + userData?.last_name,
        "billing_state": userData.state,
        "billing_tel": userData.mobile_number,
        "billing_zip": "",
        "cancel_url": this.ccavenue.redirectURL,
        "currency": "INR",
        "customer_identifier": "",
        "delivery_address": "",
        "delivery_city": "",
        "delivery_country": "India",
        "delivery_name": userData?.first_name + " " + userData?.last_name,
        "delivery_state": userData.state,
        "delivery_tel": userData.mobile_number,
        "delivery_zip": "",
        "language": "EN",
        "merchant_id": this.ccavenue.merchant_id,
        "order_id": leadResponse["data"].payment_order_id,
        "promo_code": "",
        // "sub_account_id":subAccId,
        "redirect_url": this.ccavenue.redirectURL
      },

      working_key: this.ccavenue.workingKey,
    };
    // if (isVasAvailable) {

    //   data.data["split_tdr_charge_type"] = "M",
    //     data.data["merComm"] = "0";
    //   data.data["split_data_list"] = [
    //     { "splitAmount": VasData.vas_payble_amount, "subAccId": (this.ccavenue.subAccId).toString() },
    //     { "splitAmount": leadResponse["data"]?.lead_info.final_amount / 100, "subAccId": (subAccId).toString() }
    //   ]

    // } else {
      data.data["sub_account_id"] = subAccId

    // }
    // response["data"].payment_amount/100
    this.payMessage =
      "Your payment of ₹" +
      this.formatMoney(finalAmount) +
      "/-";


      const objthank: ThankuResponse = {} as ThankuResponse;
      objthank.headMessage = "Thank You !";
      objthank.payMessage = this.payMessage;
      objthank.Image = this.imageUrl;
      objthank.orderId = leadResponse["data"].payment_order_id;
      objthank.leadInfo = leadInfo;
      objthank.reqId = leadResponse["data"].lead_row_id;
      objthank.vehicleID = vehicleData["id"];
      objthank.vehicleModel = vehicleData["model"];
      objthank.orderAmount = leadResponse["data"].payment_amount / 100;
      objthank.productUrl = window.location.href;
      objthank.payment_gateway = "CCAVENUE";

      localStorage.removeItem('Payresponse');

      this.localStorage.setItem("Payresponse", JSON.stringify(objthank));

    this.sub.add(this.apiService.getCCEncTokenDetail(data).subscribe({
      next: (res: any) => {
        if (res.success) {

          let encRequest = res.data;
          let ccavenuForm: FormGroup = this.formBuilder.group({
            encRequest: [encRequest],
            access_code: [this.ccavenue.accessCode],
          });

          this.payWithCcavenu(ccavenuForm, VasData);
        } else {
          this.toastrService.warning("Payment Aborted");
        }
      }
    })
    );
  }
  payWithCcavenu(formGroup: FormGroup, VasData) {
      if (VasData) { localStorage.removeItem('VASData') }

      const myform = document.createElement("form");
      myform.method = "POST";
      myform.action = this.ccavenue.baseurl;
      let input: any;
      for (const [key, value] of Object.entries(formGroup.value)) {
        input = document.createElement("input");
        input.name = key;
        input.id = key;
        input.value = value;
        myform.appendChild(input);
      }
      myform.style.display = "none";
      myform.append("Content-Type", "application/x-www-form-urlencoded");
      myform.append(
        "Accept",
        "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8"
      );
      document.body.appendChild(myform);
      myform.submit();
    }
  formatMoney(amount: any, decimalCount = 2, decimal = ".", thousands = ",") {
    if (isPlatformBrowser(this.platformId)) {
      try {
        let i: any;
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
        const negativeSign = amount < 0 ? "-" : "";
        i = parseInt(
          (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
        ).toString();
        let j = i.length > 3 ? i.length % 3 : 0;
        return (
          negativeSign +
          (j ? i.substr(0, j) + thousands : "") +
          i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
          (decimalCount
            ? decimal +
            Math.abs(amount - i)
              .toFixed(decimalCount)
              .slice(2)
            : "")
        );
      } catch (e) { }
    }
  }
  clevertapPayementcompFailed() {

    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onPaymentCompleted(
          "Success",
          "Online Transfer",
          this.leadInfo?.lead_info["id"],
          this.leadInfo?.lead_info["model"],
          this.imageUrl,
          "Top Navigation",
          this.leadInfo['sub_lob'],
          this.leadInfo?.lead_info['lob'],
          this.leadInfo?.lead_info['ppl'],
          this.leadInfo.ex_showroom_amount ? this.leadInfo.ex_showroom_amount : "",
          this.leadInfo['booking_amount'],
          this.leadInfo['payment_amount'] / 10,
        );
      } catch { }
    }
  }

  clevertapPayementFailed() {
    if (isPlatformBrowser(this.platformId)) {

      try {
        this.cleverService.onPaymentfailed(
          this.leadInfo?.lead_info["id"],
          "Online Transfer",
          this.imageUrl,

          this.leadInfo?.lead_info["model"],
          "Top Navigation",
          this.leadInfo['sub_lob'],
          this.leadInfo?.lead_info['lob'],
          this.leadInfo?.lead_info['ppl'],
          this.leadInfo.ex_showroom_amount ? this.leadInfo.ex_showroom_amount : "",
          this.leadInfo['booking_amount'],
          this.leadInfo['payment_amount'] / 10,
        );
      } catch { }
    }
  }
  getEncryptionccavenue() {
    let req = {
      "type": "ccavenue",
      "filter": environment.ccavenueType
    }

    try {
      this.sub.add(this.apiService.getCCEncDetail(req).subscribe({
        next: (res: any) => {
          if (res.success) {
            if (isPlatformBrowser(this.platformId)) {

              let decrypt = this.localStorage.decryptData(res.data);
              this.ccavenue = JSON.parse(decrypt.replaceAll(`'`, `"`));

              return this.ccavenue;
            }
          }

        },
        error: () => {
        },
        complete: () => {
        }
      }))
    } catch (error) {
    }
  }


  clevertap() {
    if (isPlatformBrowser(this.platformId)) {

      try {
        var baseurl = window.location.href;
        this.cleverService.proceedToPayment(
          this.leadInfo.first_name,
          this.leadInfo.last_name,
          this.leadInfo.mobile_number,
          this.leadInfo.email_id,
          this.leadInfo.state,
          this.leadInfo.city,
          this.leadInfo?.lead_info.district,
          this.leadInfo?.lead_info.taluka,
          this.leadInfo?.lead_info.pincode,

          this.leadInfo.dealer_name,
          "BOOKING",
          this.leadInfo?.lead_info.finance ? this.leadInfo?.lead_info.finance : "",
          this.leadInfo?.lead_info.quantity,
          this.leadInfo.id,
          this.leadInfo?.cover_image,
          this.leadInfo?.lead_info.model,
          baseurl,
          this.leadInfo.ex_showroom_amount ? this.leadInfo.ex_showroom_amount : "",
          this.leadInfo.booking_amount,
          this.leadInfo?.lead_info.dse_username,
          "",
          this.leadInfo?.lead_info.finance,
          this.leadInfo?.lead_info.amc,
          "",
          "",
          "",
          "",
          this.leadInfo.sub_lob,
          this.leadInfo?.lead_info.lob,
          this.leadInfo?.lead_info.ppl,
          this.router.url
        );
      } catch (error) { }
    }
  }
}
export class PaymentResponse {
  razorpay_payment_id: string = '';
  razorpay_order_id: string = '';
  razorpay_signature: string = '';
}


